<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
     <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="运营审批人">
              <a-input placeholder="运营审批人" v-model="queryParam.operateName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="财务审批人">
              <a-input placeholder="财务审批人" v-model="queryParam.financialName"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="8">
            <a-form-item label="认证状态">
              <a-select v-model="queryParam.certificationStatus" placeholder="请选择认证状态">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="0">待认证</a-select-option>
                <a-select-option value="1">认证中</a-select-option>
                <a-select-option value="2">已认证</a-select-option>
                <a-select-option value="3">认证失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <!-- <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('退款审核')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">
 
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <el-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <a v-if="scope.status == 0" title="0000000000" href="javascript:;" class="gmbbp_table_more infohref" @click="detailsVisibleOpen(scope.row)">
              <i class="el-icon-info"/>
            </a>
            <a v-if="scope.status == 1" title="1111111111" class="gmbbp_table_edit" @click="editOpen(scope.row.id)">
              <i class="el-icon-edit"/>
            </a>
            <a v-if="scope.status == 2" title="2222222" class="gmbbp_table_phone " @click="service(scope.row.equipmentid)">
              <i class="el-icon-view"/>
            </a>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status"   label="当前状态" width="250px" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.status == 0"
              style="color: #F56C6C"
            >女</span>
            <span
              v-else-if="scope.row.status == 1"
              style="color: #1f201f"
            >男</span>
            <span
              v-else-if="scope.row.status == 2"
              style="color: #E6A23C"
            >保密</span>
          </template>
        </el-table-column> -->
        <span slot="action" slot-scope="text, record">
          <a @click="audit(record)">审核</a>&nbsp;&nbsp;
          <!-- <a @click="handleEdit(record)">编辑</a> -->
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <register-refound-audit ref="auditCL"></register-refound-audit>
    <register-refound-audit-modal ref="modalForm" @ok="modalFormOk"></register-refound-audit-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import RegisterRefoundAuditModal from './modules/RegisterRefoundAuditModal'
  import RegisterRefoundAudit from './modules/RegisterRefoundAudit'
  export default {
    name: 'RegisterRefoundAuditList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      RegisterRefoundAuditModal,
      RegisterRefoundAudit
    },
    data () {
      return {
        description: '退款审核管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'openid',
          //   align:"center",
          //   dataIndex: 'openid'
          // },
          {
            title:'申请日期',
            align:"center",
            dataIndex: 'requestTime;'
          },
          {
            title:'手机号',
            align:"center",
            dataIndex: 'mobile'
          },
          {
            title:'患者姓名',
            align:"center",
            dataIndex: 'patientName'
          },
          {
            title:'患者身份证号',
            align:"center",
            dataIndex: 'idCard'
          },
          {
            title:'运营审批',
            align:"center",
            dataIndex: 'operateAudit'
          },
          {
            title:'运营审批人',
            align:"center",
            dataIndex: 'operateName'
          },
          {
            title:'运营驳回原因',
            align:"center",
            dataIndex: 'operateReason'
          },
          {
            title:'运营驳回时间',
            align:"center",
            dataIndex: 'operateTime'
          },
          {
            title:'财务审批',
            align:"center",
            dataIndex: 'financialAudit'
          },
          {
            title:'财务审批人',
            align:"center",
            dataIndex: 'financialName'
          },
          {
            title:'财务驳回原因',
            align:"center",
            dataIndex: 'financialReason'
          },
          {
            title:'财务驳回时间',
            align:"center",
            dataIndex: 'financialTime'
          },
          {
            title:'协商退款原因',
            align:"center",
            dataIndex: 'xsResion'
          },
          {
            // title:'退款状态，0-申请退款，1-运营审核同意，2-运营审核驳回，3-财务审核通过，4-财务审核驳回，5-完成退款',
            title:'退款状态',
            align:"center",
            dataIndex: 'status',
            scopedSlots: { customRender1: 'status' },
            customRender: function(text, record, index){
              let v = '';
              switch(text){
                case 0: v = '申请退款';break;
                case 1: v = '运营审核同意';break;
                case 2: v = '运营审核驳回';break;
                case 3: v = '财务审核通过';break;
                case 4: v = '财务审核驳回';break;
                case 5: v = '完成退款';break;
              }
              return v;
            },
          },
          {
            title:'支付id',
            align:"center",
            dataIndex: 'registerPayOrderId'
          },
          {
            title:'默认微信支付',
            align:"center",
            dataIndex: 'payTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/registerRefoundAudit/registerRefoundAudit/list",
          delete: "/registerRefoundAudit/registerRefoundAudit/delete",
          deleteBatch: "/registerRefoundAudit/registerRefoundAudit/deleteBatch",
          exportXlsUrl: "/registerRefoundAudit/registerRefoundAudit/exportXls",
          importExcelUrl: "registerRefoundAudit/registerRefoundAudit/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      audit(record ){
        this.$refs.auditCL.viewShow(record );
        // if(record.status < 1){
        //   this.$message.warning("患者还未支付，不可操作！")
        // }else if(record.status == 2 || record.status == 3){
        //   this.$message.warning("已处理完成！")
        // }else{
        //   this.$refs.audit.viewShow(record );
        // }
        
      },
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>